import React from 'react';

const MuiCheckboxUncheckedIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="4" y="4" width="16" height="16" rx="3" stroke="#626F88" strokeWidth={2} />
  </svg>
);

export default MuiCheckboxUncheckedIcon;
